import { Injectable } from '@angular/core';
import { ApiService } from 'merlin-library';
import { ClinicianApiEndPointConstants } from 'projects/clinician/src/app/utilitites/api-end-point-constants';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OneTimeWizardService {
    constructor(private apiService: ApiService) {}

    emailValidate(payload) {
        return this.apiService.post(ClinicianApiEndPointConstants.userUniqueEmailCheck(), payload);
    }
    setOneTimeWizardConsent(payload) {
        return this.apiService.put(ClinicianApiEndPointConstants.oneTimeWizardCall(), payload);
    }
    enablePrimaryEmail(primaryEmailAddress) {
        return this.apiService.get(ClinicianApiEndPointConstants.enablePrimaryEmailCheck(primaryEmailAddress));
    }

}
